// Runtime feature flags. Values come from window.__PUBLIC_CONFIG__ (injected
// by /config.js in Docker) or PUBLIC_* env vars in local dev — flipping a flag
// on staging/prod is an env change + container restart, no rebuild.
import { publicConfig } from "@/config/public-config";

export type FeatureName =
  | "manual_review"
  | "revenue_report"
  | "hide_promotion_simulate"
  | "hide_returns"
  | "settlement_panel";

export function isFeatureEnabled(feature: FeatureName): boolean {
  switch (feature) {
    case "manual_review":
      return publicConfig.FEATURE_MANUAL_REVIEW === "true";
    case "revenue_report":
      return publicConfig.FEATURE_REVENUE_REPORT === "true";
    case "hide_promotion_simulate":
      return publicConfig.FEATURE_HIDE_PROMOTION_SIMULATE === "true";
    case "hide_returns":
      return publicConfig.FEATURE_HIDE_RETURNS === "true";
    case "settlement_panel":
      return publicConfig.FEATURE_SETTLEMENT_PANEL === "true";
  }
}
